import { UserSearchParamDTO } from "./UserSearchParamDTO"

export class EditUserModel
{
     PermissionSet:string
     ID :number
      NameEN :string
      NameAR :string
      Username :string
      SamAccount :string
      Email :string
      ValidationError: string
      EntityID?:number
      Mobile:string
      IsCurrent:number
      PermissionIDs:number[]= new Array<number>();
      SendMail: boolean
      IsAnonymous:boolean
      DepartmentID?:number
      Filters:UserSearchParamDTO
}